(() => {
  if (window.elThemeControls) { window.elThemeControls(); return; }
  function showSlide(root, index) {
    const slides=[...root.querySelectorAll('.el-sp__slide')];
    const count=root.querySelector('[data-el-count]');
    const n=slides.length ? (index+slides.length)%slides.length : 0;
    root.dataset.slide=String(n);
    slides.forEach((s,i)=>s.classList.toggle('is-active',i===n));
    root.querySelectorAll('.el-sp__pic').forEach((p,i)=>p.classList.toggle('is-active',i===n));
    if(count)count.textContent=slides.length ? `${n+1} / ${slides.length}` : '0 / 0';
    root.querySelectorAll('[data-el-prev],[data-el-next]').forEach(b=>b.disabled=slides.length<2);
  }
  function chooseTab(tab) {
    const root=tab.closest('.el-sym');
    root.querySelectorAll('[role=tab]').forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});
    root.querySelectorAll('[role=tabpanel]').forEach(p=>p.classList.toggle('is-active',p.id===tab.getAttribute('aria-controls')));
  }
  function init() {
    document.querySelectorAll('.el-sp').forEach(root=>showSlide(root,Number(root.dataset.slide)||0));
  }
  window.elThemeControls=init;
  document.addEventListener('click',event=>{
    const tab=event.target.closest('.el-sym__tab');
    if(tab)chooseTab(tab);
    const nav=event.target.closest('[data-el-prev],[data-el-next]');
    if(nav){const root=nav.closest('.el-sp');showSlide(root,(Number(root.dataset.slide)||0)+(nav.hasAttribute('data-el-next')?1:-1));}
    const chip=event.target.closest('.el-pg__chip');
    if(chip){
      const root=chip.closest('.el-pg');let visible=0;
      root.querySelectorAll('.el-pg__chip').forEach(c=>c.setAttribute('aria-pressed',String(c===chip)));
      root.querySelectorAll('[data-el-card]').forEach(card=>{const match=chip.dataset.elGoal==='*'||card.dataset.elCard===chip.dataset.elGoal;card.classList.toggle('is-hidden',!match);if(match)visible++;});
      const empty=root.querySelector('[data-el-empty]');if(empty)empty.hidden=visible>0;
    }
    const thumb=event.target.closest('.el-pd__thumb');
    if(thumb){const root=thumb.closest('.el-pd');root.querySelectorAll('.el-pd__thumb').forEach(t=>t.setAttribute('aria-current',String(t===thumb)));root.querySelectorAll('.el-pd__main img').forEach((im,i)=>im.classList.toggle('is-active',i===Number(thumb.dataset.elIndex)));}
  });
  document.addEventListener('keydown',event=>{
    const tab=event.target.closest('.el-sym__tab');
    if(!tab||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
    event.preventDefault();const tabs=[...tab.closest('.el-sym').querySelectorAll('[role=tab]')];
    let n=tabs.indexOf(tab)+(event.key==='ArrowLeft'?-1:1);
    if(event.key==='Home')n=0;if(event.key==='End')n=tabs.length-1;
    const next=tabs[(n+tabs.length)%tabs.length];chooseTab(next);next.focus();
  });
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:block:select',event=>{
    const block=event.target;const tab=block.matches('.el-sym__tab')?block:block.querySelector('.el-sym__tab');if(tab)chooseTab(tab);
    const root=block.closest('.el-sp');if(root){const slides=[...root.querySelectorAll('.el-sp__slide')];const index=slides.findIndex(s=>s===block||s.contains(block));if(index>=0)showSlide(root,index);}
  });
  document.addEventListener('DOMContentLoaded',init);init();
})();
